module.exports = __webpack_public_path__ + "img/settings.28f9f7f5.svg";